import React from 'react';
import { Tooltip as TippyTooltip, TooltipProps } from 'react-tippy';

type TooltipWithChildren = TooltipProps & {
	children: React.ReactNode;
};

const Tooltip = (props: TooltipWithChildren) => <TippyTooltip {...props} />;

export default Tooltip;
